import { useEffect, useRef, useState, type ReactNode } from "react";

// Page scaffold (docs/ui-foundation.md). PMPageHeader's anatomy (title ·
// context line · actions) at a larger, calmer scale, plus a condensed glass
// bar that takes over once the header scrolls away so the title and primary
// actions stay reachable on long pages.
export function Page({ title, subtitle, actions, children, wide }: { chip?: string; title: ReactNode; subtitle?: ReactNode; actions?: ReactNode; children: ReactNode; wide?: boolean }) {
  const head = useRef<HTMLElement>(null);
  const [stuck, setStuck] = useState(false);
  useEffect(() => {
    const el = head.current;
    if (!el) return;
    const root = el.closest(".shell-content");
    const io = new IntersectionObserver(([e]) => setStuck(!e.isIntersecting), { root, threshold: 0, rootMargin: "-40px 0px 0px 0px" });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <div className={`page ${wide ? "page--wide" : ""}`}>
      <div className={`ph-bar pm-glass ${stuck ? "is-on" : ""}`} aria-hidden={!stuck}>
        <span className="ph-bar-title">{title}</span>
        <div className="ph-actions">{stuck ? actions : null}</div>
      </div>
      <header className="ph" ref={head}>
        <div className="ph-text">
          <h1>{title}</h1>
          {subtitle && <p className="ph-sub">{subtitle}</p>}
        </div>
        {actions && <div className="ph-actions">{actions}</div>}
      </header>
      <div className="page-body">{children}</div>
    </div>
  );
}

export function Eyebrow({ children, count, action }: { children: ReactNode; count?: number; action?: ReactNode }) {
  return (
    <div className="eyebrow">
      <span>{children}</span>
      {count !== undefined && <span className="count-pill">{count}</span>}
      {action && <span className="eyebrow-action">{action}</span>}
    </div>
  );
}
